module.exports = __webpack_public_path__ + "img/disponible-en-google-play.e028f9f1.svg";